const AMINO_ACIDS_PER_SEGMENT = 10;
const AMINO_ACIDS_PER_LINE = 50;

/**
 * Convert the amino acids into a readable text format. Each line starts with
 * the index of the start of that line, and we keep two spaces between the line
 * number and the line contents.
 *
 * For example:
 * 0    MVHLTPEEKS AVTALWGKVN VDEVGGEALG RLLVVYPWTQ RFFESFGDLS
 * 50   TPDAVMGNPK VKAHGKKVLG AFSDGLAHLD NLKGTFATLS ELHCDKLHVD
 * 100  PENFRLLGNV LVCVLAHHFG KEFTPPVQAA YQKVVAGVAN ALAHKYH
 */
function formatAminoAcids(aminoAcids: string): string {
  const lines = [];
  const lastLineStart = aminoAcids.length - (aminoAcids.length % AMINO_ACIDS_PER_LINE);
  const maxLineNumberWidth = `${lastLineStart}`.length + 2;
  for (let lineStart = 0; lineStart < aminoAcids.length; lineStart += AMINO_ACIDS_PER_LINE) {
    const segments = [];
    for (
      let segmentStart = lineStart;
      segmentStart < Math.min(lineStart + AMINO_ACIDS_PER_LINE, aminoAcids.length);
      segmentStart += AMINO_ACIDS_PER_SEGMENT
    ) {
      segments.push(aminoAcids.substr(segmentStart, AMINO_ACIDS_PER_SEGMENT));
    }
    let lineNumberStr = `${lineStart}`;
    while (lineNumberStr.length < maxLineNumberWidth) {
      lineNumberStr += ' ';
    }
    const line = lineNumberStr + segments.join(' ');
    lines.push(line);
  }
  return lines.join('\n');
}

export default formatAminoAcids;
